import intl from 'react-intl-universal'

class WebAPIError {
    constructor(error) {
        this.error = error;
        this.code = error.response.status;
        this.setMessage(error)
    }

    setMessage = (error) => {
        let message = ""
        if (typeof error.response.data === "string")
            message = error.response.data
        if (!message && typeof error.response.data.message === "string")
            message = error.response.data.message
        if (!message && error.response.data) {
            if (error.response.data[0])
                if (typeof error.response.data[0].description === "string")
                    message = error.response.data[0].description
        }
        if (!message && typeof error.response === "string")
            message = error.response
        console.log("pak error", message, error);
        
        if (message === undefined || message === null || message === '') {
            if (this.code == 401)
            message = intl.get("err.unauthorized_access")
            else if (this.code == 403)
            message = intl.get("err.access_denied")
            else if (this.code == 404)
            message = intl.get("err.method_not_found")
            else if (this.code == 400)
            message = intl.get("err.bad_request")
            else if (this.code == 500)
            message = intl.get("err.server_failure")
            else
            message = intl.get("err.unknown")
            
        } 
        if (!message)
            message = error.response.statusText
        this.message = message;
    }
}
WebAPIError.prototype.toString = function () {
    return this.error;
}
export default WebAPIError;